import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Megapack después de comprar?',
  a: 'Acceso digital inmediato por email tras el pago aprobado, en menos de 5 minutos; PDFs descargables para siempre.'
}, {
  q: '¿Sirve si mi hijo acaba de ser diagnosticado?',
  a: 'Sí — incluye el Plan de 30 días para saber por dónde empezar desde cero.'
}, {
  q: '¿Necesito tener conocimientos previos sobre el TDAH?',
  a: 'No — todo está explicado en lenguaje simple, sin tecnicismos, con un glosario incluido.'
}, {
  q: '¿Los 6 bonos están incluidos en las dos ofertas?',
  a: 'Sí, los 6 bonos vienen completos en ambas opciones.'
}, {
  q: '¿Sirve si mi hijo tiene TDAH más otra condición (TEA, ansiedad, dislexia)?',
  a: 'Sí — las estrategias de rutinas, crisis y comunicación son útiles en combinación con otras condiciones, aunque no reemplazan tratamiento profesional.'
}, {
  q: '¿Sirve para papás también o es solo para mamás?',
  a: 'Para ambos — está escrito para cualquier adulto que acompañe al niño.'
}, {
  q: '¿Qué diferencia tiene con los recursos gratuitos de Instagram?',
  a: 'Es un sistema completo, ordenado y aplicable, no tips sueltos que no se sostienen.'
}, {
  q: '¿Por qué elegir el Megapack Pro y no la versión estándar?',
  a: 'Suma los Tomos 7 y 8: pre-adolescencia y autocuidado parental, por solo $10.000 más.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí — 7 días, devolución del 100% sin preguntas. Tasa de devoluciones menor al 1%.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 md:py-20 bg-white" data-id="element-86">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
        <SectionHeader title="PREGUNTAS FRECUENTES" data-id="element-88" />

        <div className="space-y-3 md:space-y-4" data-id="element-89">
          {faqs.map((faq, i) => <div key={i} className="border border-[#1E2A4A]/10 rounded-xl overflow-hidden bg-[#FBF7F0]/50" data-id="element-90">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 py-3 md:px-6 md:py-4 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E76F51]" aria-expanded={openIndex === i} data-id="element-91">
                <span className="font-bold text-[#1E2A4A] text-sm md:text-base pr-4" data-id="element-92">
                  {faq.q}
                </span>
                <ChevronDown className={`shrink-0 text-[#E76F51] transition-transform duration-200 ${openIndex === i ? 'rotate-180' : ''}`} size={18} data-id="element-93" />
              </button>

              <AnimatePresence data-id="element-94">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-95">
                    <div className="px-4 pb-3 md:px-6 md:pb-4 text-[#1E2A4A]/80 text-sm md:text-base leading-relaxed" data-id="element-96">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}